module.exports = __webpack_public_path__ + "ed7cf009fdbfb4285b618af1d025e31a.png";